<template>
  <van-dialog
    :show="showNotify"
    :confirm-button-text="$t('close')"
    confirm-button-color="#007AFF"
    class="metfone-confim-unsubscribe"
  >
    <template #title>
      <div class="metfone-dialog-title">{{ $t("confirmation") }}</div>
    </template>
    <template #default>
      <div class="metfone-dialog-description">{{ $t("close_content") }}</div>
    </template>
    <template #footer>
      <div class="metfone-bottom-button">
        <van-button
          @click="handleNo()"
          class="metfone-bottom-btn metfone-bottom-btn-no"
        >
          {{ $t("close_cancel") }}
        </van-button>
        <van-button
          @click="handleYes()"
          class="metfone-bottom-btn metfone-bottom-btn-yes"
        >
          {{ $t("close_comfirm") }}
        </van-button>
      </div>
    </template>
  </van-dialog>
</template>
<script>
import { Dialog } from "vant";
import store from "@/store";

export default {
  name: "CloseDialog",
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    [Dialog.name]: Dialog,
  },
  watch: {
    isShow(value) {
      this.showNotify = value;
    },
  },
  mounted() {
    this.showNotify = this.isShow;
  },
  data() {
    return {
      showNotify: false,
    };
  },
  created() {
    // this.showNotify = true;
    this.showNotify = this.isShow;
  },
  methods: {
    handleNo() {
      this.showNotify = false;
      this.$emit("update:isShow", false);
      this.$store.dispatch("routerStore/setActionClose", false);
    },
    handleYes() {
      if (this.$bridge && typeof this.$bridge.callHandler === "function") {
        this.$bridge.callHandler("closeApp");
      }
    },
  },
};
</script>

<style lang="scss">
.metfone-confim-unsubscribe {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .metfone-dialog-title {
    color: #000;
    text-align: center;
    font-family: SF Pro Text;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    padding-top: 4px;
  }

  .metfone-dialog-description {
    line-height: 10px;
    gap: 10px;
    align-self: stretch;
    color: #000;
    text-align: center;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: -0.078px;
    //padding-bottom: 16px;
    padding-right: 16px;
    padding-left: 16px;
  }

  .metfone-bottom-button {
    display: flex;
    justify-content: space-around;
    //border-top: 1px solid #EAECF0;

    padding: 16px;
    gap: 12px;

    .metfone-bottom-btn {
      width: 100%;
      border-radius: 8px;
    }

    .metfone-bottom-btn-no {
    }

    .metfone-bottom-btn-yes {
      border-radius: 8px;
      border: 1px solid #b81627;
      background: #b81627;
      color: #fff;
      /* Shadow/xs */
      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    }
  }
}
</style>
